<div class="dg" [style.height.px]="height">
  <div class="dg_content">
    <table class="dg_table">
      <thead class="dg_head">
        <tr class="dg_head-row">
          @for (col of colList; track col) {
            <th
              class="dg_th"
              [class.dg_th--sortable]="isSortable(col)"
              [class.dg_th--command]="col.isCommand"
              [style.width.px]="col.width"
              [attr.aria-sort]="isSortable(col) ? ariaSort(col) : null"
              scope="col"
              (click)="onSort(col)">
              <span class="dg_th-inner">
                <span class="dg_th-title">{{ col.title }}</span>
                @if (sortDir(col)) {
                  <span class="dg_sort-icon">
                    <i class="fas" [class.fa-caret-up]="sortDir(col) === 'asc'" [class.fa-caret-down]="sortDir(col) === 'desc'"></i>
                  </span>
                }
              </span>
            </th>
          }
        </tr>

        @if (filterable) {
          <tr class="dg_filter-row">
            @for (col of colList; track col) {
              <th class="dg_th dg_th--filter">
                @if (isFilterable(col) && col.filterCellTemplate) {
                  <ng-container
                    [ngTemplateOutlet]="col.filterCellTemplate.templateRef"
                    [ngTemplateOutletContext]="filterContext(col)"
                    [ngTemplateOutletInjector]="filterInjector">
                  </ng-container>
                }
              </th>
            }
          </tr>
        }
      </thead>

      <tbody class="dg_body">
        @for (row of rows; track $index) {
          <tr class="dg_row">
            @for (col of colList; track col) {
              <td class="dg_td" [style.width.px]="col.width">
                @if (col.cellTemplate) {
                  <ng-container *ngTemplateOutlet="col.cellTemplate.templateRef; context: cellContext(row)"></ng-container>
                } @else {
                  {{ col.field ? row[col.field] : '' }}
                }
              </td>
            }
          </tr>
        }

        @if (rows.length === 0 && !loading) {
          <tr class="dg_row dg_row--empty">
            <td class="dg_td dg_td--empty" [attr.colspan]="colList.length || 1">
              No records available.
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (pageable && showPager) {
    <app-grid-pager
      [total]="total"
      [skip]="skip"
      [pageSize]="pageSize"
      (pageChange)="onPageChange($event)">
    </app-grid-pager>
  }

  @if (loading) {
    <div class="dg_loading">
      <div class="dg_loading-spinner"></div>
    </div>
  }
</div>
